import { type DocumentNode, gql } from '@apollo/client';

const createFieldMapsMutation: DocumentNode = gql`
  mutation create_field_maps($externalFieldId: String!, $fieldDefId: ID!, $fieldMapConfigId: ID!) {
    createFieldMap(externalFieldId: $externalFieldId, fieldDefId: $fieldDefId, fieldMapConfigId: $fieldMapConfigId) {
      fieldMap {
        id
        fieldMapConfig {
          id
          name
        }
        externalFieldId
      }
    }
  }
`;

export default createFieldMapsMutation;
